import authSlice from './authSlice';
import driverInfoSlice from './driverInfoSlice';

// Combine your all reducers here
const rootReducers = {
    auth: authSlice,
    driverInfo: driverInfoSlice
};
export default rootReducers;
